import React, { useState, useEffect } from 'react';

interface IProps {
    time: number
    isPlay: boolean
    isEnd: (end: string) => void
}


let timer: undefined | NodeJS.Timeout;
let now: number = 0;
export default (props: IProps) => {
    const [total] = useState<number>(props.time)
    const [tn, setTn] = useState<number>(0)
    const [isPlay, setIsPlay] = useState<boolean>(props.isPlay)
    

    const [countTime, setCountTime] =useState<string>("--:--")
    const [countBar, setCountBar] =useState<number>(0)

    const resetTimer = () => {
        now=0;
        setTn(0);
    }
    const startTimer = () => {
        const totalTime:number = Date.now() + (60000 * props.time)
        timer = setInterval(() => {
            const _d:Date = new Date(totalTime - Date.now())
            let _m = _d.getHours() > 8 ? _d.getMinutes() + 60 : _d.getMinutes();
            if (_d.getMinutes() > 0) {
                //document.querySelector("#timeout").innerHTML = _m + "分" + _d.getSeconds() + "秒";
                //console.log(_m + "分" + _d.getSeconds() + "秒")
                setCountTime(_m+"分:"+ _d.getSeconds()+"秒" )
            } else {
                //document.querySelector("#timeout").innerHTML = _d.getSeconds() + "秒";
                //console.log( _d.getSeconds() + "秒")
                setCountTime( _d.getSeconds().toString() +"秒")
            }

            setCountBar(Math.floor((totalTime-Date.now())/(60000 * props.time)*100))
            
            if(_d.getTime() <=0){
                stopTimer()      
            }

        }, 500)
    }
    const stopTimer = () => {
        if (timer != undefined) {
            clearInterval(timer)
            props.isEnd("end")
        }
    }
    useEffect(() => {
        console.log(isPlay)
        if (props.isPlay) {      
            resetTimer();
            startTimer()
        } else {
            stopTimer()
        }
    }, [props.isPlay])

    if (tn != total) {
        return (
            <div className='exam-timer'>
                <span >
                    <i className="fas fa-clock"></i>
                    <span style={{marginRight:10}}>
                        剩餘時間
                    </span>
                    {countTime}
                </span>
                <div style={{ width: countBar + "%", height: 6, backgroundColor: "#f00", transition: ".5s" }}></div>
            </div>
        )
    } else {
        return (
            <div>Times Up!</div>
        )
    }
}